"use client";

import { useEffect, useRef, useState } from "react";
import { useRouter } from "next/navigation";

function formatClock(totalSeconds: number) {
  const s = Math.max(0, Math.round(totalSeconds));
  const m = Math.floor(s / 60);
  const sec = s % 60;
  return `${m}:${sec.toString().padStart(2, "0")}`;
}

// 모의고사 제한시간 카운트다운. 0에 도달하면 새로고침만 해준다 — 실제 채점
// 완료 처리는 서버(quiz-core.ts의 finalizeIfExpired)가 조회 시점에 알아서
// 하므로, 여기서는 그 결과를 화면에 반영하기 위해 다시 불러오기만 하면 된다.
export function ExamTimer({ deadlineAt }: { deadlineAt: string }) {
  const router = useRouter();
  const deadline = new Date(deadlineAt).getTime();
  const [remaining, setRemaining] = useState(() =>
    Math.round((deadline - Date.now()) / 1000),
  );
  const refreshedRef = useRef(false);

  useEffect(() => {
    const interval = setInterval(() => {
      const left = Math.round((deadline - Date.now()) / 1000);
      setRemaining(left);
      if (left <= 0 && !refreshedRef.current) {
        refreshedRef.current = true;
        router.refresh();
      }
    }, 1000);
    return () => clearInterval(interval);
  }, [deadline, router]);

  const low = remaining <= 300;

  return (
    <span className={low ? "font-semibold text-red-500" : "text-foreground/60"}>
      남은 시간 {formatClock(remaining)}
    </span>
  );
}
